import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";
import { useStateContext } from "../../../contexts/ContextProvider";
import { Loader } from "../../../components";
import { FetchErrorHandling } from "../../../components/FetchErrorHandling";
import { postRequest } from "../../../constants/api";
import { handleLogout } from "../../../constants/logoutHelper";
import { validatePassword } from "../../../constants/validatePassword";
import { Container, Card, Form, Row, Col, ProgressBar } from "react-bootstrap";
import {
  Box,
  Button,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
  Autocomplete,
  TextField,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import useScreenWidth from "../../../hooks/useScreenWidth";

const UbahUser = () => {
  const [isFetchError, setIsFetchError] = useState(false);
  const screenSize = useScreenWidth();
  const { user, setting, dispatch } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [username, setUsername] = useState("");
  const [usernameLama, setUsernameLama] = useState("");
  const [tipeUser, setTipeUser] = useState("");
  const [password, setPassword] = useState("");
  const [kodeCabang, setKodeCabang] = useState("");
  const [cabangs, setCabangs] = useState([]);

  // Akses Master
  const [checkAllAkses, setCheckAllAkses] = useState(false);

  const [kategori, setKategori] = useState(false);
  const [barang, setBarang] = useState(false);
  const [bukuBesar, setBukuBesar] = useState(false);
  const [supplier, setSupplier] = useState(false);
  const [pelanggan, setPelanggan] = useState(false);
  const [cabang, setCabang] = useState(false);

  // Akses Toko
  const [stokToko, setStokToko] = useState(false);
  const [koreksiStokToko, setKoreksiStokToko] = useState(false);

  // Akses Beli
  const [pembelian, setPembelian] = useState(false);
  const [pembayaranHutang, setPembayaranHutang] = useState(false);

  // Akses Penjualan
  const [penjualan, setPenjualan] = useState(false);
  const [pembayaranPiutang, setPembayaranPiutang] = useState(false);

  // Akses Laporan
  const [laporanStokBarang, setLaporanStokBarang] = useState(false);
  const [laporanPembelianBarang, setLaporanPembelianBarang] = useState(false);
  const [laporanPembelian, setLaporanPembelian] = useState(false);
  const [laporanPenjualan, setLaporanPenjualan] = useState(false);
  const [laporanBarangHpp, setLaporanBarangHpp] = useState(false);

  // Akses Finance
  const [kasMasuk, setKasMasuk] = useState(false);
  const [kasKeluar, setKasKeluar] = useState(false);
  const [bankMasuk, setBankMasuk] = useState(false);
  const [bankKeluar, setBankKeluar] = useState(false);

  // Akses Accounting
  const [posting, setPosting] = useState(false);
  const [unposting, setUnposting] = useState(false);
  const [aktivitasBukuBesar, setAktivitasBukuBesar] = useState(false);
  const [neracaSaldo, setNeracaSaldo] = useState(false);
  const [labaRugi, setLabaRugi] = useState(false);
  const [neraca, setNeraca] = useState(false);
  const [jurnal, setJurnal] = useState(false);

  // Akses Utility
  const [profilUser, setProfilUser] = useState(false);
  const [daftarUser, setDaftarUser] = useState(false);
  const [tutupPeriode, setTutupPeriode] = useState(false);
  const [gantiPeriode, setGantiPeriode] = useState(false);
  const [settingAkses, setSettingAkses] = useState(false);

  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);

  const handleClickOpenAlert = () => {
    setOpenAlert(true);
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const tipeUserOption = [
    {
      label: "MANAGER",
    },
    {
      label: "ADMIN",
    },
  ];
  const tipeUserOptionOwner = [
    {
      label: "OWNER",
    },
    {
      label: "MANAGER",
    },
    {
      label: "ADMIN",
    },
  ];
  const cabangOption = cabangs.map((cabang) => ({
    label: `${cabang.id} - ${cabang.namaCabang}`,
  }));

  const strengthLabels = [
    "Sangat Lemah",
    "Lemah",
    "Kurang Kuat",
    "Baik",
    "Kuat",
  ];
  const strengthColors = ["danger", "danger", "warning", "info", "success"];

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    getCabangsData();
    getUserById();
  }, []);

  const getCabangsData = async () => {
    const response = await postRequest(`/cabangs`, {}, navigate, dispatch);
    setCabangs(response.data);
  };

  const getUserById = async () => {
    setLoading(true);
    const response = await postRequest(
      `/findUser/${id}`,
      {},
      navigate,
      dispatch
    );
    setUsername(response.data.username);
    setUsernameLama(response.data.username);
    setTipeUser(response.data.tipeUser);
    setKodeCabang(
      `${response.data.cabang.id} - ${response.data.cabang.namaCabang}`
    );

    // Akses Master
    setKategori(response.data.akses.kategori);
    setBarang(response.data.akses.barang);
    setBukuBesar(response.data.akses.bukuBesar);
    setSupplier(response.data.akses.supplier);
    setPelanggan(response.data.akses.pelanggan);
    setCabang(response.data.akses.cabang);

    // Akses Toko
    setStokToko(response.data.akses.stokToko);
    setKoreksiStokToko(response.data.akses.koreksiStokToko);

    // Akses Beli
    setPembelian(response.data.akses.pembelian);
    setPembayaranHutang(response.data.akses.pembayaranHutang);

    // Akses Penjualan
    setPenjualan(response.data.akses.penjualan);
    setPembayaranPiutang(response.data.akses.pembayaranPiutang);

    // Akses Laporan
    setLaporanStokBarang(response.data.akses.laporanStokBarang);
    setLaporanPembelianBarang(response.data.akses.laporanPembelianBarang);
    setLaporanPembelian(response.data.akses.laporanPembelian);
    setLaporanPenjualan(response.data.akses.laporanPenjualan);
    setLaporanBarangHpp(response.data.akses.laporanBarangHpp);

    // Akses Finance
    setKasMasuk(response.data.akses.kasMasuk);
    setKasKeluar(response.data.akses.kasKeluar);
    setBankMasuk(response.data.akses.bankMasuk);
    setBankKeluar(response.data.akses.bankKeluar);

    // Akses Accounting
    setPosting(response.data.akses.posting);
    setUnposting(response.data.akses.unposting);
    setAktivitasBukuBesar(response.data.akses.aktivitasBukuBesar);
    setNeracaSaldo(response.data.akses.neracaSaldo);
    setLabaRugi(response.data.akses.labaRugi);
    setNeraca(response.data.akses.neraca);
    setJurnal(response.data.akses.jurnal);

    // Akses Utility
    setProfilUser(response.data.akses.profilUser);
    setDaftarUser(response.data.akses.daftarUser);
    setTutupPeriode(response.data.akses.tutupPeriode);
    setGantiPeriode(response.data.akses.gantiPeriode);
    setSettingAkses(response.data.akses.setting);

    setLoading(false);
  };

  const updateUser = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (
      form.checkValidity() &&
      tipeUser.length != 0 &&
      kodeCabang.length != 0
    ) {
      if (password.length !== 0) {
        if (!validatePassword(password)["validation"]) {
          alert("Password tidak cukup kuat!");
          return;
        }
      }

      setLoading(true);
      const tempUsername = await postRequest(
        `/getUsername`,
        { username },
        navigate,
        dispatch
      );
      let isUsernameNotValid =
        tempUsername.data.length > 0 && username !== usernameLama;
      if (isUsernameNotValid) {
        handleClickOpenAlert();
      } else {
        setLoading(true);
        await postRequest(
          `/users/${id}`,
          {
            username,
            tipeUser,
            password,
            akses: {
              kategori,
              barang,
              bukuBesar,
              supplier,
              pelanggan,
              cabang,

              stokToko,
              koreksiStokToko,

              pembelian,
              pembayaranHutang,

              penjualan,
              pembayaranPiutang,

              laporanStokBarang,
              laporanPembelianBarang,
              laporanPembelian,
              laporanPenjualan,
              laporanBarangHpp,

              kasMasuk,
              kasKeluar,
              bankMasuk,
              bankKeluar,

              posting,
              unposting,
              aktivitasBukuBesar,
              neracaSaldo,
              labaRugi,
              neraca,
              jurnal,

              profilUser,
              daftarUser,
              tutupPeriode,
              gantiPeriode,
              setting: settingAkses,
            },
            cabangId: kodeCabang.split(" -", 1)[0],
          },
          navigate,
          dispatch
        );
        setLoading(false);

        if (user.id == id) {
          handleLogout(dispatch, navigate);
        } else {
          navigate("/daftarUser");
        }
      }
      setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  const textRightSmall = {
    textAlign: screenSize >= 650 && "right",
    fontSize: "14px",
  };

  if (loading) {
    return <Loader />;
  }

  if (isFetchError) {
    return <FetchErrorHandling />;
  }

  return (
    <Container>
      <h3>Utility</h3>
      <h5 style={{ fontWeight: 400 }}>Ubah User</h5>
      <Dialog
        open={openAlert}
        onClose={handleCloseAlert}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Data Username Sama`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {`Username ${username} sudah ada, ganti Username!`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAlert}>Ok</Button>
        </DialogActions>
      </Dialog>
      <hr />
      <Card>
        <Card.Header>User</Card.Header>
        <Card.Body>
          <Form noValidate validated={validated} onSubmit={updateUser}>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    Username :
                  </Form.Label>
                  <Col sm="9">
                    <Form.Control
                      required
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      style={{ textTransform: "uppercase" }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    Tipe User :
                  </Form.Label>
                  <Col sm="9">
                    <Autocomplete
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={
                        user.tipeUser === "OWNER"
                          ? tipeUserOptionOwner
                          : tipeUserOption
                      }
                      value={tipeUser}
                      renderInput={(params) => (
                        <TextField
                          size="small"
                          error={error && tipeUser.length === 0 && true}
                          helperText={
                            error &&
                            tipeUser.length === 0 &&
                            "Tipe User harus diisi!"
                          }
                          {...params}
                        />
                      )}
                      onChange={(e, value) => {
                        if (value) {
                          setTipeUser(value.label);
                        } else {
                          setTipeUser("");
                        }
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    Password :
                  </Form.Label>
                  <Col sm="9">
                    <Form.Control
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      style={{ textTransform: "uppercase" }}
                      placeholder="Isi jika ingin mengganti Password!"
                    />

                    {/* Password Strength Meter */}
                    {password && (
                      <>
                        <ProgressBar
                          variant={
                            strengthColors[validatePassword(password)["score"]]
                          }
                          now={(validatePassword(password)["score"] + 1) * 20}
                          className="mt-2"
                        />
                        <small className="text-muted">
                          {strengthLabels[validatePassword(password)["score"]]}
                        </small>
                        <p>{[validatePassword(password)["feedback"]]}</p>
                      </>
                    )}
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    Cabang :
                  </Form.Label>
                  <Col sm="9">
                    {user.tipeUser === "OWNER" ? (
                      <Autocomplete
                        size="small"
                        disablePortal
                        id="combo-box-demo"
                        options={cabangOption}
                        renderInput={(params) => (
                          <TextField
                            size="small"
                            error={error && kodeCabang.length === 0 && true}
                            helperText={
                              error &&
                              kodeCabang.length === 0 &&
                              "Cabang harus diisi!"
                            }
                            {...params}
                          />
                        )}
                        onChange={(e, value) => {
                          if (value) {
                            setKodeCabang(value.label);
                          } else {
                            setKodeCabang("");
                          }
                        }}
                      />
                    ) : (
                      <Form.Control
                        required
                        value={kodeCabang}
                        disabled
                        readOnly
                      />
                    )}
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Container style={{ marginTop: 30 }}>
              <h4>Hak Akses User</h4>
              <Box sx={showDataContainerCheck}>
                <Row>
                  <Col>
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox checked={checkAllAkses} />}
                        label="Pilih Semua"
                        onChange={() => {
                          setCheckAllAkses(!checkAllAkses);
                          // Akses Master
                          setKategori(!checkAllAkses);
                          setBarang(!checkAllAkses);
                          setBukuBesar(!checkAllAkses);
                          setSupplier(!checkAllAkses);
                          setPelanggan(!checkAllAkses);
                          setCabang(!checkAllAkses);

                          // Akses Toko
                          setStokToko(!checkAllAkses);
                          setKoreksiStokToko(!checkAllAkses);

                          // Akses Beli
                          setPembelian(!checkAllAkses);
                          setPembayaranHutang(!checkAllAkses);

                          // Akses Penjualan
                          setPenjualan(!checkAllAkses);
                          setPembayaranPiutang(!checkAllAkses);

                          // Akses Laporan
                          setLaporanStokBarang(!checkAllAkses);
                          setLaporanPembelianBarang(!checkAllAkses);
                          setLaporanPembelian(!checkAllAkses);
                          setLaporanPenjualan(!checkAllAkses);
                          setLaporanBarangHpp(!checkAllAkses);

                          // Akses Finance
                          setKasMasuk(!checkAllAkses);
                          setKasKeluar(!checkAllAkses);
                          setBankMasuk(!checkAllAkses);
                          setBankKeluar(!checkAllAkses);

                          // Akses Accounting
                          setPosting(!checkAllAkses);
                          setUnposting(!checkAllAkses);
                          setAktivitasBukuBesar(!checkAllAkses);
                          setNeracaSaldo(!checkAllAkses);
                          setLabaRugi(!checkAllAkses);
                          setNeraca(!checkAllAkses);
                          setJurnal(!checkAllAkses);

                          // Akses Utility
                          setProfilUser(!checkAllAkses);
                          setDaftarUser(!checkAllAkses);
                          setTutupPeriode(!checkAllAkses);
                          setGantiPeriode(!checkAllAkses);
                          setSettingAkses(!checkAllAkses);
                        }}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </Box>
              <Box sx={showDataContainerCheck}>
                <Row>
                  <Col>
                    <Typography variant="p" sx={[spacingTop]}>
                      Master
                    </Typography>
                    <Form>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={kategori} />}
                          label="Kategori"
                          onChange={() => setKategori(!kategori)}
                        />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={barang} />}
                          label="Barang"
                          onChange={() => setBarang(!barang)}
                        />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={bukuBesar} />}
                          label="Buku Besar"
                          onChange={() => setBukuBesar(!bukuBesar)}
                        />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={supplier} />}
                          label="Supplier"
                          onChange={() => setSupplier(!supplier)}
                        />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={pelanggan} />}
                          label="Pelanggan"
                          onChange={() => setPelanggan(!pelanggan)}
                        />
                      </FormGroup>
                      {tipeUser !== "ADMIN" && (
                        <FormGroup>
                          <FormControlLabel
                            control={<Checkbox checked={cabang} />}
                            label="Cabang"
                            onChange={() => setCabang(!cabang)}
                          />
                        </FormGroup>
                      )}
                    </Form>
                    <Typography variant="p" sx={[spacingTop]}>
                      Stok
                    </Typography>
                    <Form>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={stokToko} />}
                          label="Stok Toko"
                          onChange={() => setStokToko(!stokToko)}
                        />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={koreksiStokToko} />}
                          label="Koreksi Stok Toko"
                          onChange={() => setKoreksiStokToko(!koreksiStokToko)}
                        />
                      </FormGroup>
                    </Form>
                    <Typography variant="p" sx={[spacingTop]}>
                      Beli
                    </Typography>
                    <Form>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={pembelian} />}
                          label="Pembelian"
                          onChange={() => setPembelian(!pembelian)}
                        />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={pembayaranHutang} />}
                          label="Pembayaran Hutang"
                          onChange={() =>
                            setPembayaranHutang(!pembayaranHutang)
                          }
                        />
                      </FormGroup>
                    </Form>
                    <Typography variant="p" sx={[spacingTop]}>
                      Penjualan
                    </Typography>
                    <Form>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={penjualan} />}
                          label="Penjualan"
                          onChange={() => setPenjualan(!penjualan)}
                        />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={pembayaranPiutang} />}
                          label="Pembayaran Piutang"
                          onChange={() =>
                            setPembayaranPiutang(!pembayaranPiutang)
                          }
                        />
                      </FormGroup>
                      <Typography variant="p" sx={[spacingTop]}>
                        Laporan
                      </Typography>
                      {/* <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={laporanStokBarang} />}
                          label="Lap. Stok Barang"
                          onChange={() =>
                            setLaporanStokBarang(!laporanStokBarang)
                          }
                        />
                      </FormGroup> */}
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox checked={laporanPembelianBarang} />
                          }
                          label="Lap. Pembelian Barang"
                          onChange={() =>
                            setLaporanPembelianBarang(!laporanPembelianBarang)
                          }
                        />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={laporanPembelian} />}
                          label="Lap. Pembelian"
                          onChange={() =>
                            setLaporanPembelian(!laporanPembelian)
                          }
                        />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={laporanPenjualan} />}
                          label="Lap. Penjualan"
                          onChange={() =>
                            setLaporanPenjualan(!laporanPenjualan)
                          }
                        />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={laporanBarangHpp} />}
                          label="Lap. Barang Hpp"
                          onChange={() =>
                            setLaporanBarangHpp(!laporanBarangHpp)
                          }
                        />
                      </FormGroup>
                    </Form>
                  </Col>
                  <Col>
                    <Form>
                      <Typography variant="p" sx={[spacingTop]}>
                        Finance
                      </Typography>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={kasMasuk} />}
                          label="Kas Masuk"
                          onChange={() => setKasMasuk(!kasMasuk)}
                        />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={kasKeluar} />}
                          label="Kas Keluar"
                          onChange={() => setKasKeluar(!kasKeluar)}
                        />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={bankMasuk} />}
                          label="Bank Masuk"
                          onChange={() => setBankMasuk(!bankMasuk)}
                        />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={bankKeluar} />}
                          label="Bank Keluar"
                          onChange={() => setBankKeluar(!bankKeluar)}
                        />
                      </FormGroup>
                      <Typography variant="p" sx={[spacingTop]}>
                        Accounting
                      </Typography>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={posting} />}
                          label="Posting"
                          onChange={() => setPosting(!posting)}
                        />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={unposting} />}
                          label="Unposting"
                          onChange={() => setUnposting(!unposting)}
                        />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={aktivitasBukuBesar} />}
                          label="Aktivitas Buku Besar"
                          onChange={() =>
                            setAktivitasBukuBesar(!aktivitasBukuBesar)
                          }
                        />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={neracaSaldo} />}
                          label="Neraca Saldo"
                          onChange={() => setNeracaSaldo(!neracaSaldo)}
                        />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={labaRugi} />}
                          label="Laba Rugi"
                          onChange={() => setLabaRugi(!labaRugi)}
                        />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={neraca} />}
                          label="Neraca"
                          onChange={() => setNeraca(!neraca)}
                        />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={jurnal} />}
                          label="Jurnal"
                          onChange={() => setJurnal(!jurnal)}
                        />
                      </FormGroup>
                    </Form>
                    <Typography variant="p" sx={[spacingTop]}>
                      Utility
                    </Typography>
                    <Form>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={profilUser} />}
                          label="Profil User"
                          onChange={() => setProfilUser(!profilUser)}
                        />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={tutupPeriode} />}
                          label="Tutup Periode"
                          onChange={() => setTutupPeriode(!tutupPeriode)}
                        />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox checked={gantiPeriode} />}
                          label="Ganti Periode"
                          onChange={() => setGantiPeriode(!gantiPeriode)}
                        />
                      </FormGroup>
                      {tipeUser !== "ADMIN" && (
                        <>
                          <FormGroup>
                            <FormControlLabel
                              control={<Checkbox checked={daftarUser} />}
                              label="Daftar User"
                              onChange={() => setDaftarUser(!daftarUser)}
                            />
                          </FormGroup>
                          <FormGroup>
                            <FormControlLabel
                              control={<Checkbox checked={settingAkses} />}
                              label="Setting"
                              onChange={() => setSettingAkses(!settingAkses)}
                            />
                          </FormGroup>
                        </>
                      )}
                    </Form>
                  </Col>
                </Row>
              </Box>
            </Container>
            <Box sx={spacingTop}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => navigate("/daftarUser")}
                sx={{ marginRight: 2 }}
              >
                {"< Kembali"}
              </Button>
              <Button
                variant="contained"
                startIcon={<EditIcon />}
                type="submit"
              >
                Edit
              </Button>
            </Box>
          </Form>
        </Card.Body>
      </Card>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
    </Container>
  );
};

export default UbahUser;

const showDataContainerCheck = {
  mt: 4,
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const showDataContainer = {
  mt: 4,
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const showDataWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const checkboxTitle = {
  marginBottom: 0,
};

const secondCheckboxTitle = {
  marginTop: 15,
  marginBottom: 0,
};
